module.exports = __webpack_public_path__ + "img/kk-facebook.ebf7507b.png";